import blankTabIcon from '@assets/images/common/icon/blank-tab/blank-tab-white.svg';
import { COMPANY_URL } from '@src/routes/company';

const Footer = () => {
  const renderNavItem = (label: string, href: string) => {
    return (
      <li>
        <a
          className='flex gap-1 text-white'
          href={href}
          target='_blank'
        >
          {label}
          <img
            src={blankTabIcon}
            alt='新しいタブで開く'
            width={18}
            height={18}
          />
        </a>
      </li>
    );
  };
  return (
    <footer className='flex flex-wrap items-center justify-between gap-x-8 gap-y-[48px] bg-primary-700 px-[100px] py-6 lg:px-6 md:flex-col md:items-start md:pb-4 md:pt-10'>
      <ul className='flex gap-x-10 gap-y-6 md:flex-col'>
        {renderNavItem('お問い合わせ', COMPANY_URL.CONTACT)}
        {renderNavItem('利用規約', COMPANY_URL.TERMS)}
        {renderNavItem('プライバシーポリシー', COMPANY_URL.PRIVACY_POLICY)}
      </ul>
      <small className='text-sm text-white md:w-full md:text-center'>
        Copyright© NTT DX Partner All right reserved.
      </small>
    </footer>
  );
};

export default Footer;
